// Arricchisce Sentry con context su carrello, B2B, promo, app attive.
// Aggiornato all'avvio + ogni 5s. Retry se Sentry non è ancora pronto.

(function init(attempts) {
  attempts = attempts || 0;
  if (!window.Sentry || typeof window.Sentry.setTag !== 'function') {
    if (attempts < 10) setTimeout(function() { init(attempts + 1); }, 300);
    return;
  }

  function detectApps() {
    return {
      monster_cart_loaded: typeof window.monster_refresh === 'function',
      bss_b2b_active: !!document.querySelector('[bss-b2b-cart-price-active="true"]'),
      tnc_loaded: !!document.querySelector('[id*="tnc"], [class*="tnc-"], script[src*="terms-and-conditions"], script[src*="effective-apps"]'),
      simple_bundles_loaded: typeof window.SimpleBundles !== 'undefined' || !!document.querySelector('script[src*="simple-bundles"]')
    };
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(r) { return r.ok ? r.json() : null; })
      .catch(function() { return null; });
  }

  function getPromoFromStorage() {
    try {
      var raw = localStorage.getItem('activePromo');
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      return parsed && parsed.type ? parsed.type : 'unknown';
    } catch (e) { return null; }
  }

  function refresh() {
    var apps = detectApps();

    Sentry.setTag('cart.is_b2b', !!window.isB2BCustomer || apps.bss_b2b_active);
    Sentry.setTag('app.monster_cart', apps.monster_cart_loaded);
    Sentry.setTag('app.tnc', apps.tnc_loaded);
    Sentry.setTag('app.simple_bundles', apps.simple_bundles_loaded);

    Sentry.setContext('apps', apps);

    fetchCart().then(function(cart) {
      if (!cart) return;

      var hasBundle = (cart.items || []).some(function(item) {
        return (item.sku || '').indexOf('kit-') === 0;
      });
      var promoCode = getPromoFromStorage();

      Sentry.setTag('cart.has_bundle', hasBundle);
      Sentry.setTag('cart.has_promo', !!promoCode);
      Sentry.setTag('cart.is_empty', cart.item_count === 0);
      if (promoCode) Sentry.setTag('cart.promo_code', promoCode);

      Sentry.setContext('cart', {
        item_count: cart.item_count,
        total_price_cents: cart.total_price,
        currency: cart.currency,
        has_bundle: hasBundle,
        has_promo: !!promoCode,
        promo_code: promoCode,
        skus: (cart.items || []).map(function(i) { return i.sku; })
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }
  setInterval(refresh, 5000);

  window.faanSentryContextRefresh = refresh;
})();
